import {Component, Input} from '@angular/core';
import {IAttachedInStatusNode} from '../../../../models/graph.model';
import {CrmService} from '../../../../services/api/crm.service';
import {DomSanitizer} from '@angular/platform-browser';
import {GraphKnDialogService} from '../../services/graph-kn.dialog.service';

@Component({
    selector: 'app-attachments-list',
    templateUrl: './attachments-list-form.component.html',
    styleUrl: './attachments-list-form.component.scss'
})
export class AttachListFormComponent {
    @Input() attachments: IAttachedInStatusNode[] = []
    @Input() attachType: 'file' | 'photo' = 'file'
    @Input() task_alias: string|undefined = undefined

    constructor(
        private knDialogService: GraphKnDialogService,
        private crmService: CrmService,
        private domSanitizer: DomSanitizer
    ) {
    }

    openFile(documentKey: string, attachment_type: 'file' | 'photo', file_name?: string) {
        switch (attachment_type) {
            case 'file':
                this.knDialogService.openDocViewComponent(documentKey)
                break;
            case 'photo':
                this.task_alias? this.openImage(documentKey, this.task_alias, file_name || '') : null
                break;
        }
    }

    openImage(ukey: string, taskAlias: string, file_name: string) {
        this.crmService.getTaskImage(taskAlias, ukey).subscribe(res => {
            let link = this.domSanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(res))
            this.knDialogService.openImageViewer(link, file_name)
        });
    };
}